import { defineComponent } from "vue";
import BaseControl from "@/library/templates/default/controls/BaseControl";
import { controlStateStore } from "@/library/stores/ControlStateStore";
import { XmlHelper } from "@/helpers/Xml";
// TODO: SPLIT from BaseControl.ts option based functionality to this component (RadioButtonList,ComboBox,RadioButtonListSection) will inherit from this class not from BaseControl - Vue 3 have extendable components.
export default defineComponent({
  extends: BaseControl,
  created() {
    this.state.selectedOptionIndex = null;
    this.loadOptions();
  },
  data() {
    let store = controlStateStore(this.identifier as string);
    // this.mtdt.XpathText
    let normalizedXpath = "";
    let xmlNodeSelector = "";
    let xmlLastNodeSelector = "";

    if (this.mtdt.XpathText && this.mtdt.XmlNodeSelector && this.mtdt.LDT.UseTextFromLookup) {
      normalizedXpath = this.mtdt.XpathText;
      xmlNodeSelector = this.mtdt.XmlNodeSelector as string;
      xmlLastNodeSelector = xmlNodeSelector.split(" > ").pop() as string;
      store.config.normalizedXpath = normalizedXpath;
      store.config.xmlNodeSelector = xmlNodeSelector;
      store.config.xmlLastNodeSelector = xmlLastNodeSelector;
    }

    store.state.selectedOption = null;
    store.state.selectedOptionIndex = null;
    store.state.optionsOpen = false;

    return {
      defaultState: {
        isValid: true,
        hidden: this.mtdt.IsHidden,
        readOnly: this.mtdt.ReadOnlyFlag,
        hiddenLabel: this.mtdt.HasHiddenLabel === null ? false : (this.mtdt.HasHiddenLabel as boolean),
        hiddenHint: false,
        customMask: this.mtdt.CustomMask,
        value: this.mtdt.DefaultValue ? this.mtdt.DefaultValue : null,
        displayValue: "",
        required: this.mtdt.IsRequired,
        description: this.mtdt.Description,
        name: this.mtdt.Name,
        masked: this.mtdt.IsMasked,
        parent: this.mtdt.Parent,
        classes: "",
        options: store.state.defaultOptions,
      },
    };
  },
  computed: {
    options() {
      return this.state.options;
      // ToDo
      // return this.state.displayedOptions;
    },
    optionsBoxId() {
      return this.identifier + "-options";
    },
    getSelectedOption() {
      if (this.state.selectedOption) {
        return this.state.selectedOption;
      } else {
        if (this.state.options) {
          let option = this.state.options.find((opt: any) => opt.Value == this.state.value);
          if (option) {
            return option;
          }
        }
      }
      return this.state.value;
    },
  },
  watch: {
    "state.value": {
      handler(newValue, oldValue) {
        //console.log("OptionBaseControl state.value => ",this.identifier,newValue,oldValue);
        if (newValue !== this.state.selectedOption?.Value) {
          if (this.state.options) {
            let option = this.state.options.find((opt: any) => opt.Value == newValue);
            if (option) {
              this.selectOption(option);
            } else {
              this.mtdt.LDT.FieldType === "ComboBox" ? this.setOptionToNull() : "";
            }
          }
        }
        if (newValue !== oldValue) {
          if (!this.state.silentValueChangeEvent) {
            window.FormEngine.events.publish(
              window.FormEngine.events.list.VALUE_CHANGE,
              {
                validableId: this.identifier,
                control: this,
                from: oldValue,
                to: newValue,
              },
              this.identifier
            );
          } else {
            this.state.silentValueChangeEvent = false;
          }
        }
        if (!this.state.silentSetValue) {
          // ToDo pri formularoch nebolo ziaduce validovat na zmenu ktoru vykonal pouzivatel.
          //console.log("Validate =>",newValue,oldValue);
          this.validate(this.fillErrorBagComputed);
        } else {
          //console.log('silentSetValue being set to false =>',newValue,oldValue,this.state.silentSetValue);
          this.state.silentSetValue = false;
        }
      },
      deep: true,
      //immediate:true,
    },
  },
  methods: {
    loadOptions() {
      if (this.mtdt.LookupID) {
        let lookups = window.FormEngine.structure.lookups.get(String(this.mtdt.LookupID)) as Array<ILookup>;
        //console.log(lookups);
        this.state.defaultOptions = lookups ? lookups : ([] as Array<ILookup>);
        this.state.options = lookups ? lookups : ([] as Array<ILookup>);
        this.state.displayedOptions = [] as Array<ILookup>;
      }
    },
    setValue(value: string, silent: boolean = false, optionAttr: string = "Value") {
      this.state.silentSetValue = silent;
      if (this.state.options) {
        // console.log("Setting with value ", value);
        let option = this.state.options.find((opt: any) => opt[optionAttr] == value);
        if (option) {
          //console.log("Setting with option ", option);
          //this.state.value = option.Value;
          this.selectOption(option);
        } else {
          this.mtdt.LDT.FieldType === "ComboBox" || this.mtdt.LDT.FieldType === "RadioButtonListSection" ? this.setOptionToNull() : "";
          // console.log("No option found for value ", value, " in control " + this.identifier);
        }
      } else {
        // console.log("No option found for control " + this.identifier + " and value " + value);
      }
    },
    setOptionToNull() {
      let oldValue = this.state.selectedOption;
      this.state.selectedOption = null;
      this.state.value = null;
      window.FormEngine.events.publish(
        window.FormEngine.events.list.VALUE_SELECTED,
        {
          validableId: this.identifier,
          control: this,
          from: oldValue,
          to: null,
        },
        this.identifier
      );
    },

    reset(silent: boolean = true) {
      this.setValue(this.defaultState.value ? this.defaultState.value : null, silent);
      //this.config.editedParentRowNumber = null;
      this.state.options = this.state.defaultOptions;
      this.state.selectedOption = null;
      //console.log("RESET IN OPTIONBASEDCONTROL CALLED");
      //this.state.silentSetValue = false;
      //this.resetErrors();
    },
    getOption(value: string) {
      if (this.state.options) {
        let option = this.state.options.find((opt: any) => opt.Value == value);
        if (option) {
          return option as ILookup;
        } else {
          // console.log("Could not find option :", value, this.identifier);
        }
      } else {
        // console.log("Component DOESN'T HAVE OPTIONS!", this.identifier);
        return null;
      }
    },
    disableOption(optionValue: string) {
      let opt = this.getOption(optionValue);
      if (opt) {
        opt.Disabled = true;
      }
    },
    enableOption(optionValue: string) {
      let opt = this.getOption(optionValue);
      if (opt) {
        opt.Disabled = false;
      }
    },
    selectOption(option: ILookup) {
      let oldValue = this.state.selectedOption;
      this.state.selectedOption = option;
      //console.log("selectOption was called on: " + this.identifier, "OptionValue: " + option.Value, "State.value: " + this.state.value);
      if (this.state.value !== option.Value) {
        this.state.value = option.Value;
        // console.log(this.state.value,option.Value);
      } else {
        this.state.silentSetValue = false;
      }
      if (this.mtdt.LDT.FieldType === "RadioButtonListSection" && option) {
        this.handleSectionToggle(option.Value as string);
      }

      if (this.mtdt.LDT.FieldType === "Autocomplete" && option) {
        this.state.value = option.Text;
        this.closeSelection();
      }

      window.FormEngine.events.publish(
        window.FormEngine.events.list.VALUE_SELECTED,
        {
          validableId: this.identifier,
          control: this,
          from: oldValue,
          to: option,
        },
        this.identifier
      );
    },
    handleSectionToggle(value: string, skipValidation: boolean = true) {
      for (let sectionIndex in this.mtdt.Tree) {
        let tempSectionRef = window.FormEngine.form.sections.get(sectionIndex);
        if (tempSectionRef) {
          if (sectionIndex == this.getOptionSectionId(value)) {
            tempSectionRef.show();
          } else {
            tempSectionRef.reset();
            tempSectionRef.hide(skipValidation);
          }
        } else {
          // console.log("SOMETHING something went wrong", value,sectionIndex);
        }
      }
    },
    handleXmlExport(parentElement: Element, topLevelXml: Element) {
      let controlValue = this.getSelectedOption;
      let relativeNodeSelector = "";
      let eventObject = {
        control: this,
        selector: relativeNodeSelector,
        value: controlValue,
        parentElement: parentElement,
        topLevelXml: topLevelXml
      };
      if (controlValue) {
        if (this.config.xmlNodeSelector && this.config.xmlNodeSelector !== "") {
          if (this.mtdt.IsTableDetailElement) {
            relativeNodeSelector =
              this.state.parentTableControl.config.xmlLastNodeSelector +
              (this.config.xmlNodeSelector as string).replace(
                this.state.parentTableControl.config?.xmlNodeSelector ? this.state.parentTableControl.config?.xmlNodeSelector : "",
                ""
              );
          } else {
            relativeNodeSelector = this.config.xmlNodeSelector;
          }
          eventObject.selector = relativeNodeSelector;
          window.FormEngine.events.publish(
            window.FormEngine.events.list.BEFORE_EXPORT,
            eventObject,
            this.identifier
          );
          XmlHelper.setElementValue(parentElement, relativeNodeSelector, eventObject.value.Text);
          window.FormEngine.events.publish(
            window.FormEngine.events.list.AFTER_EXPORT,
            eventObject,
            this.identifier
          );
        }
        if (this.config.xmlNodeCodeSelector && this.config.xmlNodeCodeSelector !== "") {
          if (this.mtdt.IsTableDetailElement) {
            relativeNodeSelector =
              this.state.parentTableControl.config.xmlLastNodeSelector +
              (this.config.xmlNodeCodeSelector as string).replace(
                this.state.parentTableControl.config?.xmlNodeSelector ? this.state.parentTableControl.config?.xmlNodeSelector : "",
                ""
              );
          } else {
            relativeNodeSelector = this.config.xmlNodeCodeSelector;
          }
          eventObject.selector = relativeNodeSelector;
          window.FormEngine.events.publish(
            window.FormEngine.events.list.BEFORE_EXPORT,
            eventObject,
            this.identifier
          );
          XmlHelper.setElementValue(parentElement, relativeNodeSelector, eventObject.value.Value);
          window.FormEngine.events.publish(
            window.FormEngine.events.list.AFTER_EXPORT,
            eventObject,
            this.identifier
          );
        }
      }
    },
    handleXmlImport(parentXml: Element, silent: boolean) {
      let nodeCodeSelector = "";
      let nodeSelector = "";
      let eventObject = {
        control: this,
        silent: silent,
        xmlValue: "",
        parentXml: parentXml
      } as {
        control: any;
        silent: boolean;
        parentXml: Element;
        xmlValue: null | string;
      };
      if (this.mtdt.IsTableDetailElement) {
        if (this.config.xmlNodeCodeSelector) {
          let relativeXmlNodeCodeSelector = this.config.xmlNodeCodeSelector
            .split(this.state.parentTableControl.config.xmlLastNodeSelector + " > ")
            .pop() as string;
          let val = parentXml.querySelector(relativeXmlNodeCodeSelector);
          if (val) {
            eventObject.xmlValue = val.textContent;
            window.FormEngine.events.publish(
              window.FormEngine.events.list.BEFORE_IMPORT,
              eventObject,
              this.identifier
            );
            this.setValue(eventObject.xmlValue, silent);
            window.FormEngine.events.publish(
              window.FormEngine.events.list.AFTER_IMPORT,
              eventObject,
              this.identifier
            );
          }
        }
        if (this.config.xmlNodeSelector) {
          let relativeXmlNodeSelector = this.config.xmlNodeSelector
            .split(this.state.parentTableControl.config.xmlLastNodeSelector + " > ")
            .pop() as string;
          let val = parentXml.querySelector(relativeXmlNodeSelector);
          if (val) {
            eventObject.xmlValue = val.textContent;
            window.FormEngine.events.publish(
              window.FormEngine.events.list.BEFORE_IMPORT,
              eventObject,
              this.identifier
            );
            this.setValue(eventObject.xmlValue, silent, "Text");
            window.FormEngine.events.publish(
              window.FormEngine.events.list.AFTER_IMPORT,
              eventObject,
              this.identifier
            );
          }
        }
      } else {
        if (this.config.xmlNodeCodeSelector) {
          nodeCodeSelector = this.config.xmlNodeCodeSelector;
        }
        if (nodeCodeSelector) {
          let val = parentXml.querySelector(nodeCodeSelector);
          if (val) {
            eventObject.xmlValue = val.textContent;
            window.FormEngine.events.publish(
              window.FormEngine.events.list.BEFORE_IMPORT,
              eventObject,
              this.identifier
            );
            this.setValue(eventObject.xmlValue, silent);
            window.FormEngine.events.publish(
              window.FormEngine.events.list.AFTER_IMPORT,
              eventObject,
              this.identifier
            );
          }
        }
        if (this.config.xmlNodeSelector) {
          nodeSelector = this.config.xmlNodeSelector;
        }
        if (nodeSelector) {
          let val = parentXml.querySelector(nodeSelector);
          if (val) {
            eventObject.xmlValue = val.textContent;
            window.FormEngine.events.publish(
              window.FormEngine.events.list.BEFORE_IMPORT,
              eventObject,
              this.identifier
            );
            this.setValue(eventObject.xmlValue, silent, "Text");
            window.FormEngine.events.publish(
              window.FormEngine.events.list.AFTER_IMPORT,
              eventObject,
              this.identifier
            );
          }
        }
      }


    },
    openSelection() {
      this.state.optionsOpen = true;
    },
    closeSelection() {
      this.state.optionsOpen = false;
    },
    getOptionSectionId(optionId: string) {
      return this.identifier + "_" + optionId;
    },
  },
});
